




import { Component, Vue } from 'vue-property-decorator'
import templateCom from '@/views/manage/roleManage/templateCom.vue'

@Component({
  name: '',
  components: {
    templateCom
  }
})
export default class extends Vue {
  dataObj = {
    url: '/blackcat/activation/type/page',
    addUrl: '/blackcat/activation/type/save',
    delUrl: '/blackcat/activation/type/delete',
    editRoleUrl: '/blackcat/activation/type/permission/assign',
    type: 'tanentRole',
    title: '现有权限组',
    pathname: 'tenantRoleSetting',
    tbHead1: '权限名称'
  }
}
